import { render } from "./SpoofingPage.vue?vue&type=template&id=2f4e5e9d&ts=true"
import script from "./SpoofingPage.vue?vue&type=script&lang=ts"
export * from "./SpoofingPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__